// removed by extract-text-webpack-plugin
module.exports = {"heading":"_3ENeD","centralHeading":"_1Qong _3ENeD","centralBody":"_9V351","centralSection":"_3SaTF","hideOnMobile":"_2oJ78"};